module.exports = __webpack_public_path__ + "img/wechat_program_code.9e72b086.png";